import React, { useContext, useRef } from 'react';
import Intl from '@fx-ui/intl';
import { get } from '~/utils';
import { UGC_MAX_LENGTH } from '~/constants';
import PersonaContext from '../../context/persona';
import PersonaCollectItem from '../persona-collect-item';
import QiXinCorpSearch from '../qixin-corp-search';

const { CORP_NAME } = UGC_MAX_LENGTH.USER;

const CorpName = () => {
    const { personaInfo, setPersonaInfo } = useContext(PersonaContext);
    const { corpName = '', companyDetail } = personaInfo || {};

    const searchInput = useRef<any>();

    return (
        <PersonaCollectItem className="fx-persona-corp-name" title={Intl.get('persona.corp.name')}>
            <QiXinCorpSearch
                placeholder={Intl.get('persona.corp.name.tip')}
                errMsg={Intl.get('max.length.error.message', { max: CORP_NAME })}
                maxLength={CORP_NAME}
                inputRef={searchInput}
                corpName={corpName}
                onInstantChange={(v) => {
                    setPersonaInfo({ corpName: v });
                }}
                onChange={(v) => {
                    setPersonaInfo({ corpName: v });
                }}
                onSelectCorp={(blur, item: any) => {
                    if (blur && companyDetail) {
                        // 仅当无选中时进行自动匹配
                        return;
                    }
                    const name = get(item, 'name', '');
                    if (name) {
                        setPersonaInfo({ corpName: name, companyDetail: item });
                    } else {
                        setPersonaInfo({ companyDetail: item });
                    }
                }}
                autoSelect={true}
                onBlur={() => {
                    searchInput.current?.closePopover();
                }}
            />
        </PersonaCollectItem>
    );
};

export default CorpName;
